const MedicalHistoryBt: React.FC<{
    isFilled: boolean;
    isSelected: boolean;
}> = ({ isFilled, isSelected }) => {
    return (
        <div className={`menuitem ${isFilled ? 'filled' : ''} ${isSelected ? 'selected' : ''}`}>
            <div>
                <div>
                    <svg width="16" height="16" viewBox="0 0 512 512">
                        {isFilled ? (
                            <path d="M447.1 112c-34.2.5-62.3 28.4-63 62.6-.5 24.3 12.5 45.6 32 56.8V344c0 57.3-50.2 104-112 104-60 0-109.2-44.1-111.9-99.2C265 333.8 320 269.2 320 192V36.6c0-11.4-8.1-21.3-19.3-23.5L237.8.5c-13-2.6-25.6 5.8-28.2 18.8L206.4 35c-2.6 13 5.8 25.6 18.8 28.2l30.7 6.1v121.4c0 52.9-42.2 96.7-95.1 97.2-53.4.5-96.9-42.7-96.9-96V69.4l30.7-6.1c13-2.6 21.4-15.2 18.8-28.2l-3.1-15.7C107.7 6.4 95.1-2 82.1.6L19.3 13C8.1 15.3 0 25.1 0 36.6V192c0 77.3 55.1 142 128.1 156.8C130.7 439.2 208.6 512 304 512c97 0 176-75.4 176-168V231.4c19.1-11.1 32-31.7 32-55.4 0-35.7-29.2-64.5-64.9-64zm.9 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"></path>
                        ) : (
                            <path d="M430.1 96.5c-43.6 1-78.7 37.5-78.1 81.1.5 38.2 27.8 69.9 64 77.2v105.6c0 65.9-57.4 119.5-128 119.5s-128-53.6-128-119.5v-8.9c71.9-8 128-69.1 128-143.1V25.8c0-5.5-3.7-10.3-9.1-11.6L223.5.4c-6.4-1.6-12.9 2.3-14.6 8.7l-1.9 7.8c-1.6 6.4 2.3 12.9 8.7 14.6l40.3 10v165.8c0 61.8-49.5 112.9-111.3 113.2-62.1.4-112.7-50-112.7-112v-167l40.2-10.1c6.4-1.6 10.3-8.1 8.7-14.6L79 9.1C77.4 2.7 70.9-1.2 64.4.4L9.1 14.2C3.7 15.5 0 20.3 0 25.8v182.6c0 74 56.1 135.1 128 143.1v8.9C128 444 199.8 512 288 512s160-68 160-151.5V254.9c36.5-7.4 64-39.7 64-78.4 0-44.9-36.9-81.1-81.9-80zm1.9 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm23.5-48c0 13-10.5 23.5-23.5 23.5s-23.5-10.5-23.5-23.5S419 153 432 153s23.5 10.5 23.5 23.5z"></path>
                        )}
                    </svg>
                </div>
                <p>Add Medical History</p>
            </div>
            <div>
                <svg
                    width="25"
                    height="25"
                    viewBox="0 0 28 28"
                    className="fill-neutral-5 cursor-pointer"
                    preserveAspectRatio="xMidYMid meet"
                >
                    {isFilled ? (
                        <path d="M10.0547 16.8125C10.2891 17.0469 10.6875 17.0469 10.9219 16.8125L17.8125 9.92188C18.0469 9.6875 18.0469 9.28906 17.8125 9.05469L16.9688 8.21094C16.7344 7.97656 16.3594 7.97656 16.125 8.21094L10.5 13.8359L7.85156 11.2109C7.61719 10.9766 7.24219 10.9766 7.00781 11.2109L6.16406 12.0547C5.92969 12.2891 5.92969 12.6875 6.16406 12.9219L10.0547 16.8125Z"></path>
                    ) : (
                        <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path>
                    )}
                </svg>
            </div>
        </div>
    );
};

export default MedicalHistoryBt;
